var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { createGlobalStyle } from "styled-components";
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  html{\n    font-size: 62.5%;\n\n  }\n\n  body {\n    font-family: 'Nunito', sans-serif;\n    ", ";\n    scrollbar-width: thin;\n    scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n  }\n"], ["\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  html{\n    font-size: 62.5%;\n\n  }\n\n  body {\n    font-family: 'Nunito', sans-serif;\n    ", ";\n    scrollbar-width: thin;\n    scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.color.fakeBlack,
        backgroundColor: theme.color.silver,
    });
});
export default GlobalStyle;
var templateObject_1;
